module.exports = __webpack_public_path__ + "img/sakuya izayoi scarlet_sc1.8a034b7c.png";